<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="fill-height">
        <div class="fs-18 text-center fw-600 title-area">{{ regDt }} 수면일지 요약</div>
        <div class="box">
          <div class="d-flex justify-space-around item">
            <div class="d-flex flex-column align-center gap-3">
              <span>총 수면시간</span>
              <span class="fs-20 fw-600">{{ totalSleepTime }}</span>
            </div>
            <div class="d-flex flex-column align-center">
              <span>수면효율</span>
              <span class="fs-20 fw-600">{{ sleepEf }}%</span>
            </div>
          </div>
          <hr>
          <div class="d-flex flex-column item">
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">잠자리에 누워있는 시간</span>
              <span class="fs-14 fw-500">{{ lieTime }}</span>
            </div>
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">잠들기까지의 시간</span>
              <span class="fs-14 fw-500">{{ sleepInc }}</span>
            </div>
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">수면 중 깬 시간</span>
              <span class="fs-14 fw-500">{{ sleepAwakeTime }}</span>
            </div>
          </div>
          <hr>
          <div class="d-flex flex-column item">
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">야간 각성빈도</span>
              <span class="fs-14 fw-500">{{ awakeFreq }}</span>
            </div>
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">수면질</span>
              <span class="fs-14 fw-500">{{ sleepQual }}</span>
            </div>
            <div class="d-flex justify-space-around">
              <span class="fs-14 gray--text">개운함</span>
              <span class="fs-14 fw-500">{{ refresh }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="$emit('next')" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>

</template>
<script>
import store from '@/store'
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: false,
    awakeFreq: 0,
    lieTime: '',
    refresh: '',
    regDt: '',
    sleepInc: '',
    sleepAwakeTime: '',
    sleepEf: '',
    sleepQual: '',
    sleepTime: '',
    totalSleepTime: '',
    wakeUpTime: '',
  }),
  components: {
    FooterBtnsNext,
  },
  created() {
    this.getSleppDiaryResult()
  },
  mounted() {
  },
  methods: {
    async getSleppDiaryResult() {
      // 유닛 사용 번호
      console.log('unitUseNo : ', this.unitUseNo)
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getSleppDiaryResult', this.$_payload('so', [{'unitUseNo': this.unitUseNo}]))
        .then(res => {
          if (res.success) {
            let result = res.data
            this.regDt = result.regDt
            this.totalSleepTime = result.totalSleepTime
            this.sleepEf = result.sleepEf
            this.lieTime = result.lieTime
            this.sleepInc = result.sleepInc
            this.sleepAwakeTime = result.sleepAwakeTime
            this.awakeFreq = result.awakeFreq
            this.sleepQual = result.sleepQual
            this.refresh = result.refresh
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.title-area {
  padding: 10px 0 24px 0;
}

.box {
  display: flex;
  flex-direction: column;
  //background: #FAFAFA;
  //padding: 0 20px;
  //margin: 0 -23px;
  //height: calc(100% - 70px);

  .item {
    padding: 40px 0;
    gap: 15px;

    > div > span {
      flex: 1;
      text-align: center;
    }
  }

  hr {
    border: none;
    background: #E8E8E8;
    height: 1px;
  }
}
</style>
